class ConfigAnalytics {
    convivaCustomerKey = '';

    constructor() {
        Object.seal(this);
    }
}

export default ConfigAnalytics;
